import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import { capitalize } from "common/api";

import SubscriberMonitorTabs from "./Tabs";
import RulesTreeHelpModal from "./Help";
import MonitorPoliciesHelpModal from "./HelpPolicies";
import RuleModal from "../../Rules/RuleModal";
import { CONST_TREE_RULE } from "../../Rules/constants";
import {
  getRulesAndConflicts,
  fetchRules,
  fetchRulesError,
  parseRules,
  parseConflicts,
  handleTabChange
} from "../../Rules/utils";
import { PROFS, POLI } from "./constants";
import ConflictsModal from "../../Rules/ConflictsModal";
import ProfMenuItem from "../../Rules/ProfMenuItem";

const ViewContainer = styled.div`
  min-height: 50vh;
  &.card {
    height: 100%;
  }
`;

const doesNothing = () => {};

const ContextMenu = ({ dpiEnabled, tab }) => {
  const actions = useContext(ActionsContext);

  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li key="menu-open-help">
        <a
          data-loading-effect="pulse"
          data-toggle="cardloading"
          title="Help"
          onClick={() => {
            if(tab===2){
              actions.send("open-help-policies");
            } else {
              actions.send("open-help");
            }
          }}
        >
          <i className="material-icons">help_outline</i>
        </a>
      </li>
      <li key="menu-refresh">
        <a
          onClick={() => actions.send("do-load")}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
      <li className="dropdown hidden-to-operators" key="menu-dropdown">
        <a
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          title="Options"
        >
          <i className="material-icons">more_vert</i>
        </a>
        <ul className="dropdown-menu pull-right">
          <li key="menu-add-rule">
            <a
              id="rulesMonitorAddRuleBtn"
              onClick={() => actions.send("open-rule-modal", { type: "Add" })}
            >
              Add Rule...
            </a>
          </li>
          <li key="menu-add-policy">
            <a
              id="rulesMonitorAddPoliBtn"
              onClick={() =>
                globalNavigate("viewPolicyMonitorEdit", {returnView: "viewRulesMonitor", tab})
              }
            >
              Add Policy...
            </a>
          </li>
          {PROFS.map( profile => (
              <ProfMenuItem
                key={profile.attr}
                {...profile}
                dpiEnabled={dpiEnabled}
                returnView="viewRulesMonitor"
              />
            )
          )}
          <li key="menu-show-conflicts">
            <a
              id="rulesMonitorShowConflictsBtn"
              onClick={() => actions.send("open-conflict-modal")}
            >
              Show Rule Conflicts...
            </a>
          </li>
        </ul>
      </li>
    </ul>
  );
};

const OPTIONS_PROFILES = [...PROFS, POLI].reduce((acc, value) => {
  const { attr } = value;
  if (attr !== "poli") {
    acc[attr] = [{ label: CONST_TREE_RULE.ANY, value: "any" }];
  } else {
    acc[attr] = [
      { label: CONST_TREE_RULE.ANY, value: "any" },
      { label: "monitor-default", value: "monitor-default" },
    ];
  }
  return acc;
}, []);

const OPTIONS_SELECTED_INIT = [...PROFS, POLI].reduce((acc, value) => {
  const { attr } = value;
  acc[attr] = "any";
  return acc;
}, {});

const SubscriberMonitoring = ({ ...params }) => {
  const { dpiEnabled, tab: paramTab } = params;
  const initTab = paramTab || 0;
  const actions = useContext(ActionsContext);
  const [tab, setTab] = useState(Number(initTab));
  const navigate = useNavigate();
  const [rules, setRules] = useState({
    rules: [],
    rulesResp: "",
    conflicts: undefined,
  });

  const doLoad = () => {
    setRules({
      rules: [],
      rulesResp: "",
      conflicts: undefined,
    });
    getRulesAndConflicts("monitor", PROFS, POLI)
      .then(([rules, conflicts]) => {
        setRules({
          rules: rules.parsedResponse,
          rulesResp: rules.response,
          conflicts,
        });
      })
      .catch((error) => {
        showModalError("Error: ", error);
      });
  };

  useEffect(() => doLoad() || actions.recv("do-load", doLoad), []);

  const { rules: rulesTree, conflicts, rulesResp } = rules;

  useEffect(() => {
    setTab(Number(params.tab) || 0);
  }, [params.tab]);

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <div className="header block-header">
          <h2>Subscriber Monitor Configuration</h2>
          <ContextMenu dpiEnabled={dpiEnabled} tab={tab} />
        </div>
        <div>
          {rules.rules.length > 0 ? (
            <SubscriberMonitorTabs
              rules={rulesTree}
              conflicts={conflicts}
              response={rulesResp}
              tab={tab}
              setTab={(tab)=>handleTabChange(tab, "viewRulesMonitor", dpiEnabled, navigate)}
            />
          ) : null}
        </div>
      </div>
      <RuleModal
        rules={rulesTree}
        optionsProfs={OPTIONS_PROFILES}
        initSelection={OPTIONS_SELECTED_INIT}
        view="monitor"
        profs={PROFS}
        poli={POLI}
      />
      <RulesTreeHelpModal />
      <MonitorPoliciesHelpModal />
      <ConflictsModal />
    </div>
  );
};

export default SubscriberMonitoring;
